import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/opt/buildhome/repo/web-app/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/blog/BlogChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/blog/BlogEngageBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/blog/BlogFeedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/SharedHeader.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/web-app/frontend/src/lib/nav-link.tsx");
